import React from "react";
import ReactDOM from "react-dom";
import { FiTrash2, FiCopy } from "react-icons/fi"

import { getCoordinates } from "../components/HighlightPlugins";

type WrapperProps = {
    selectedElementId: string;
    isCoreV3: boolean;
    type: string;
    handleDelete: (arg: string) => void;
    handleCopy: (arg: string) => void;
}

export function drawWrapper(wrapperProps: WrapperProps) {
    
    const { selectedElementId, isCoreV3, type, handleDelete, handleCopy } = wrapperProps;
    const existingWrapper = document.getElementById("wrapper");
    const mainGrid: any = document.getElementById("mainGrid");
    if (selectedElementId && isCoreV3) {
        const elem: any = document.getElementById(`${type}-${selectedElementId}`);
        const { top, left } = getCoordinates(elem, document.getElementById("mainGrid"));
        const existingWrapper = document.getElementById("wrapper");
        const scrollLeft = mainGrid.scrollLeft;
        const scrollTop = mainGrid.scrollTop;
        if (existingWrapper) {
            if (elem && elem.clientWidth && elem.clientHeight && mainGrid) {
                existingWrapper.style.display = "unset";
                existingWrapper.style.width = `${elem.clientWidth}px`;
                existingWrapper.style.height = `${elem.clientHeight}px`;
                existingWrapper.style.top = `${top - scrollTop}px`;
                existingWrapper.style.left = `${left - scrollLeft}px`;
            } else {
                console.error("Client width or height not available for the element.");
            }
            // Update the selected element ID display
            const selectElement = existingWrapper.querySelector("#selectedElementId");
            if (selectElement) {
                selectElement.innerHTML = selectedElementId;
            }
            const existingTrash = existingWrapper.querySelector(".trash-icons");
            if (existingTrash) {
                existingWrapper.removeChild(existingTrash);
            }
            // Creating the icons for delete and copy
            const trash = document.createElement("div");
            trash.className = "trash-icons";
            trash.style.display = "flex";
            trash.style.flexDirection = "row";
            trash.style.justifyContent = "space-between";
            trash.style.background = "#e7e7e7";
            trash.style.width = "40px";
            trash.style.fontSize = "11px";
            trash.style.position = "absolute";
            trash.style.borderRadius = "2px";
            trash.style.padding = "2px";
            trash.style.bottom = `0px`;
            trash.style.right = `0px`;
            trash.style.pointerEvents = 'none';

            // Create and render the trash (delete) icon
            const trashIconElement = document.createElement("div");
            trashIconElement.style.pointerEvents = 'auto';
            ReactDOM.render(
                <TrashIcon
                    selectedElementId={selectedElementId}
                    handleDelete={() => handleDelete(selectedElementId)}
                />,
                trashIconElement
            );
            trash.appendChild(trashIconElement);

            // Create and render the copy icon
            const copyIconElement = document.createElement("div");
            copyIconElement.style.pointerEvents = 'auto';
                ReactDOM.render(
                    <CopyIcon
                    selectedElementId={ selectedElementId }
                    handleCopy = {() => handleCopy(selectedElementId)}
            />,
            copyIconElement
                );
            trash.appendChild(copyIconElement);

            // Add the icons to the highlightDiv
            existingWrapper.appendChild(trash);
            existingWrapper.style.pointerEvents = 'none';
        } else {
            const highlightDiv = document.createElement("div");
            highlightDiv.id = "wrapper";
            highlightDiv.style.position = "absolute";
            highlightDiv.style.border = "1.65px solid #fe4365";
            highlightDiv.style.borderRadius = "2px";
            highlightDiv.style.pointerEvents = "none";
            highlightDiv.style.top = `${top - scrollTop}px`;
            highlightDiv.style.left = `${left - scrollLeft}px`;

            if (elem && elem.clientWidth && elem.clientHeight) {
                highlightDiv.style.width = `${elem.clientWidth}px`;
                highlightDiv.style.height = `${elem.clientHeight}px`;
            } else {
                console.error("Client width or height not available for the element.");
            }
            // Create the selected element ID display
            const selecteid = document.createElement("p");
            selecteid.setAttribute("id", "selectedElementId");
            selecteid.style.fontSize = "11px";
            selecteid.style.position = "absolute";
            selecteid.style.background = "#fe4365";
            selecteid.style.borderRadius = "2px";
            selecteid.style.padding = "2px";
            selecteid.style.color = "#fff";
            selecteid.style.bottom = `0px`;
            selecteid.style.left = `0px`;
            selecteid.innerHTML = selectedElementId;
            highlightDiv.appendChild(selecteid);

            // Append the created elements to the mainCanvas
            const formCanvas: any = document.getElementById("mainCanvas");
            formCanvas.appendChild(highlightDiv);
        }
    } else if (!selectedElementId) {
        if (existingWrapper) {
            existingWrapper.style.display = "none";
        }
        return;
    }
}

export function removeWrapper() {
    const wrapper = document.getElementById("wrapper")
    if (wrapper) {
        wrapper.remove();
    }
}

type TrashIconProps = {
    selectedElementId: string;
    handleDelete: (arg: string) => void;
}
const TrashIcon = (props: TrashIconProps) => {
    const { handleDelete, selectedElementId } = props;
    return (
        <FiTrash2
            size={"14px"}
            color="#F32727"
            style={{ cursor: "pointer" }}
            onClick={() => handleDelete(selectedElementId)}
        />
    );
};

type CopyIconProps = {
    selectedElementId: string;
    handleCopy: (arg: string) => void;
}
const CopyIcon = (props: CopyIconProps) => {
    const { handleCopy, selectedElementId } = props;
    return (
        <FiCopy
            size={"14px"}
            color="#121212"
            style={{ cursor: "pointer" }}
            onClick={() => handleCopy(selectedElementId)}
        />
    );
};